import { useState } from "react";
import { Outlet, useNavigate } from "react-router-dom";
import { GrContact } from "react-icons/gr";
import { MdHomeRepairService } from "react-icons/md";
import { AiFillProduct } from "react-icons/ai";
import { IoMdAnalytics } from "react-icons/io";
import { RiLogoutCircleLine } from "react-icons/ri";
import { Link } from "react-router-dom";
import { useAuth } from "../../hooks/useAuth";

export const Dashboard = () => {
  const navigate = useNavigate();
  const { logout, user } : any= useAuth();
  const [isLoggingOut, setIsLoggingOut] = useState(false);

  const handleLogout = async () => {
    try {
      setIsLoggingOut(true);
      await logout();
      navigate("/login");
    } catch (error) {
      console.error("Logout error:", error);
      setIsLoggingOut(false);
    }
  };

  return (
    <div className="flex flex-row h-[100vh] overflow-hidden">
      <div className="w-[18%] h-[100vh] p-[20px] flex flex-col justify-between bg-gray-800 text-white">
        <div>
          {/* Header with user info */}
          <div className="mb-8">
            <h1 className="text-2xl font-bold text-white mb-2">LOGO</h1>
            {user && (
              <div className="text-sm text-gray-300">
                <p className="truncate">{user.email}</p>
              </div>
            )}
          </div>
          
          <div className="text-[18px] space-y-2">
            <Link 
              to={"/dashboard"} 
              className="cursor-pointer flex flex-row items-center p-3 rounded-lg hover:bg-gray-700 transition-colors"
            >
              <span><IoMdAnalytics size={22} /></span>
              <span className="pl-[15px]">Analytics</span>
            </Link>
            <Link 
              to={"/dashboard/contact"} 
              className="cursor-pointer flex flex-row items-center p-3 rounded-lg hover:bg-gray-700 transition-colors"
            >
              <span><GrContact size={22} /></span>
              <span className="pl-[15px]">Contact Enquiry</span>
            </Link>
            <Link 
              to={"/dashboard/product"} 
              className="cursor-pointer flex flex-row items-center p-3 rounded-lg hover:bg-gray-700 transition-colors"
            >
              <span><AiFillProduct size={22} /></span>
              <span className="pl-[15px]">Product Enquiry</span>
            </Link>
            <Link 
              to={"/dashboard/service"} 
              className="cursor-pointer flex flex-row items-center p-3 rounded-lg hover:bg-gray-700 transition-colors"
            >
              <span><MdHomeRepairService size={22} /></span>
              <span className="pl-[15px]">Service Enquiry</span>
            </Link>
          </div>
        </div>
        
        {/* Logout Button */}
        <div className="border-t border-gray-700 pt-4">
          <button
            onClick={handleLogout}
            disabled={isLoggingOut}
            className="w-full flex flex-row items-center justify-center p-3 rounded-lg bg-red-600 hover:bg-red-700 text-white transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
          >
            {isLoggingOut ? (
              <>
                <svg className="animate-spin h-5 w-5 mr-2 text-white" fill="none" viewBox="0 0 24 24">
                  <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" />
                  <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z" />
                </svg>
                Logging out...
              </>
            ) : (
              <>
                <RiLogoutCircleLine size={22} />
                <span className="pl-[10px]">LOGOUT</span>
              </>
            )}
          </button>
          
          {/* Optional: Logout confirmation modal */}
          {/* {showLogoutConfirm && (
            <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
              <div className="bg-white rounded-lg p-6 max-w-sm mx-4">
                <h3 className="text-lg font-semibold text-gray-900 mb-4">Confirm Logout</h3>
                <p className="text-gray-600 mb-6">Are you sure you want to log out?</p>
                <div className="flex justify-end space-x-3">
                  <button
                    onClick={() => setShowLogoutConfirm(false)}
                    className="px-4 py-2 border border-gray-300 rounded-md text-gray-700 hover:bg-gray-50"
                  >
                    Cancel
                  </button>
                  <button
                    onClick={handleLogout}
                    className="px-4 py-2 bg-red-600 text-white rounded-md hover:bg-red-700"
                  >
                    Logout
                  </button>
                </div>
              </div>
            </div>
          )} */}
        </div>
      </div>
      
      {/* Main Content Area */}
      <div className="w-[82%] overflow-y-auto p-[30px] bg-gray-50">
        <Outlet />
      </div>
    </div>
  );
};